import { proxyApi } from "@/service/proxy"
import WECHATStore from "../store/common"
import { getATags } from "../components/utils/text"
import { throttle } from "lodash"
import { PostCdpLogin, PostCollect } from "../api/site"
import { isPreviewEnv } from "@/utils/previewEnv"
import { isTrustedParentIframe } from "@/utils/trustedParentIframe"

/**
 *  CDP-系统微站事件上报
 *  MINISITE_SYSTEM_CLICK_LINK: s_elementType, s_textName, s_textLink    //点击文本中链接
    MINISITE_SYSTEM_CLICK_BASICLINK: s_elementType, s_website    //点击基础链接
    MINISITE_SYSTEM_CLICK_SITEPAGE: s_elementType, s_websiteName, s_website  //点击跳转站内页面
    MINISITE_SYSTEM_CLICK_FORM: s_elementType, s_formName, s_formId, s_formInsideName    //点击跳转系统内表单
    MINISITE_SYSTEM_CLICK_LANDINGPAGE: s_elementType, s_landingPageId, s_landingPageTitle,s_landingPageInsideName        //点击跳转系统内LandingPage
    MINISITE_SYSTEM_CLICK_MINISITE: s_elementType, s_toMiniSiteAddress   //点击跳转系统内微站
    MINISITE_SYSTEM_CLICK_ATTACHMENT: s_elementType, s_attachmentName, s_attachmentId    //点击跳转系统内附件
    MINISITE_SYSTEM_CLICK_LOTTERY: s_elementType, s_lotteryId, s_lotteryType, s_lotteryTitle //点击跳转系统内抽奖
    MINISITE_SYSTEM_CLICK_LIVE: s_elementType, s_liveId, s_liveTitle, s_liveInsideName   //点击跳转系统内直播
    MINISITE_SYSTEM_CLICK_TELEPHONE: s_elementType, s_telephone  //点击拨打电话
    MINISITE_SYSTEM_CLICK_EMAIL: s_elementType, s_email  //点击发送邮件
    MINISITE_SYSTEM_CLICK_MINIPROGRAM: s_elementType, s_appId, s_pagePath, s_alternateWebLinks  //点击跳转小程序
    MINISITE_SYSTEM_CLICK_VIDEO: s_elementType, s_videoName, s_videoUrl //点击播放视频
    MINISITE_SYSTEM_CLICK_SEARCH: s_elementType, s_searchKeyword    //点击搜索
    MINISITE_SYSTEM_CLICK_COLLECT: s_elementType    //点击收藏
    MINISITE_SYSTEM_CLICK_UNCOLLECT: s_elementType  //取消收藏
    MINISITE_SYSTEM_CLICK_MUSIC: s_elementType, s_musicName, s_musicUrl //点击播放音频
    MINISITE_SYSTEM_CLICK_WECHATARTICLE: s_elementType, s_wechatArticleAddress  //点击微信图文
    MINISITE_SYSTEM_CLICK_MODAL_CONFIRM: s_elementType, s_modalId //点击弹窗确认按钮
    MINISITE_SYSTEM_OPEN_MINISITELINK    //打开微站
    MINISITE_SYSTEM_SHARE_MINISITELINK   //分享微站
 * 
 */

function SiteApi(target, data) {
    return proxyApi("site", target, data, 1)
}

export const SearchPages = async ({ siteId, index = 1, size = 999, q, lang }) => {
    return await SiteApi("searchPages", {
        siteId,
        index,
        size,
        q,
        lang
    })
}

function getCollectData(event, detail) {
    const collectData = {
        siteId: WECHATStore.state._siteId,
        pageId: WECHATStore.state._pageId,
        appId: WECHATStore.state._appId,
        openId: WECHATStore.state.WechatInfo.openid,
        unionId: WECHATStore.state.WechatInfo.unionid,
        clientId: window.ca("get", "cid"),
        path: location.href,
        title: document.title,
        query: location.search,
        hash: location.hash,
        event,
        detail
    }

    return collectData
}

function getCdpLoginBody() {
    const appId = WECHATStore.state._appId
    const { openid, unionid } = WECHATStore.state.WechatInfo

    if (!appId || !openid) return {}

    const body = {
        loginType: "wechat_identity",
        wechatAppId: appId,
        wechatOpenId: openid
    }

    if (unionid) {
        body.wechatUnionId = unionid
    }

    return body
}

export const collectMinisiteOpen = async ({ tenantId, teamId }) => {
    if (isPreviewEnv() || isTrustedParentIframe()) return

    try {
        await PostCdpLogin({
            tenantId,
            teamId,
            body: getCdpLoginBody()
        })
    } catch (error) {
        // CDP 登录失败不阻止微站打开事件上报
    }

    const data = getCollectData("MINISITE_SYSTEM_OPEN_MINISITELINK")
    return await PostCollect(data)
}

export const collect = async (event, detail) => {
    if (isPreviewEnv() || isTrustedParentIframe()) return
    const data = getCollectData(event, detail)

    return await PostCollect(data)
}

export const ClickActionType = {
    BASIC: "basic", //基础链接
    SITE_PAGES: "sitePages", //站内页面
    MATERIAL: "material", //系统内物料
    ACTIONS: "actions" //行为
}

export const ClickActionContentType = {
    /** 站内页面 */
    HOME: "home", //首页
    SITE_PAGES: "sitePages", //页面
    /** 站内页面 */

    /** 系统内物料 */
    QUESTIONNAIRE: "questionnaire",
    LANDING_PAGE: "landingpage",
    MINI_SITE: "minisite",
    ATTACHMENT: "attachment",
    LUCKY_DRAW: "luckydraw", //抽奖
    WEBINAR: "webinar", //直播
    /** 系统内物料 */

    /** 行为 */
    PHONE: "phone",
    EMAIL: "email",
    MINI_PROGRAM: "miniProgram"
}
export const ElementType = {
    text: "文本",
    image: "图片",
    button: "按钮",
    floatButton: "浮动按钮",
    collection: "收藏",
    list: "图文列表",
    toggleList: "下拉列表", //容器组件
    tagList: "标签列表", //容器
    banner: "轮播图",
    cubeNav: "魔方导航",
    nav: "顶部导航",
    tab: "底部导航",
    wechatArticle: "微信图文",
    search: "搜索",
    video: "视频",
    audio: "音频",
    bgMusic: "背景音乐",
    modal: "弹窗"
}

/** 文本中链接增加点击事件 */
export const addCollectToAElement = (text) => {
    const links = getATags(text)

    links.forEach((link) => {
        link.addEventListener("click", function (event) {
            collect("MINISITE_SYSTEM_CLICK_LINK", {
                s_elementType: ElementType.text,
                s_textName: link.innerText,
                s_textLink: link.href
            })
        })
    })
}

/** 节流上报搜索事件 */
export const collectSearch = throttle(async (keyword) => {
    collect("MINISITE_SYSTEM_CLICK_SEARCH", {
        s_elementType: ElementType.search,
        s_searchKeyword: keyword
    })
}, 500)

// 大屏抽奖
export const isBigScreen = (type) => type === 1
// 普通抽奖
export const isNormal = (type) => type === 0

// 普通抽奖 type === 0，templateType 0 | 1 | 2 | 3
export const NormalLotteryTypeArr = ["大转盘", "扭蛋机", "跑马灯", "盲盒"]

// 大屏抽奖 type === 1,templateType >= 5
export const BigScreen = "大屏抽奖"
